export enum VideoProfileEnum {
  Baseline = 0,
  Main = 1,
  High = 2,
}

export type VideoProfile =
  | VideoProfileEnum.Baseline
  | VideoProfileEnum.Main
  | VideoProfileEnum.High;
